import { gql } from '@apollo/client';

export const GET_ANNOUNCEMENTS_BY_DAY = gql`
  query announcementsByDays($announcementQuery: AnnouncementQuery) {
    announcementsByDays(input: $announcementQuery) {
      size
    }
  }
`;
